<template>
  <div class="choose-file-wrap" ref="caseFileRef">
    <div class="content">
        <xl-scrollbar>
        <xl-form :model="form" ref="formRef" label-position="top" :rules="rules" onsubmit="return false">
            <xl-form-item prop="orderName" :label="$t('design.orderDetail.caseName') || '案例名称'">
                <xl-input
                    size="large"
                    v-model="form.orderName"
                    :placeholder="$t('design.case.inputCaseName') || '请输入案例名称'"
                    style="width:264px"
                    @keydown.enter="()=>{}"
                ></xl-input>
            </xl-form-item>
            <div class="files-wrap">
                <div class="need-file" v-show="requiredFileList.length">
                    <title-name class="desc-tlt">{{$t('design.case.needFiles') || '必传文件'}}</title-name>
                    
                </div>
                <xl-form-item class="file-form-item" v-for="(item, index) in requiredFileList" :key="index">
                    <template #label>
                        <span>{{ item.title }}</span>
                        <xl-tooltip :content="item.imageRemark" placement="top">
                            <i class="iconfont icon-zhuyi" v-show="item.imageRemark"></i>
                        </xl-tooltip>
                    </template>
                    <list-uploader
                        category="dentalx" 
                        :isPrivate="false"
                        drag 
                        listType="picture" 
                        isBigFile 
                        :limit="item.limit"
                        v-model:file-list="form[item.key]"
                        :tip="item.tip"
                        :accept="item.accept"
                        :typeErrorTip="item.tip"
                        :maxSize="item.maxSize"
                        :typeErrorList="item.typeErrorList"
                        :auto-upload="true"
                        @success="uploadedsuccess" 
                        :outOfSizeTip="item.outOfSizeTip"
                        :text="$t('design.case.addOrDragFile') || '添加或拖入文件'"
                        :show-file-list="false"
                        @error="uploadErrorHandler"
                        outOfLimitHideUpload
                        ></list-uploader>
                </xl-form-item>
                <div class="need-file" v-show="optionalFileList.length">
                    <title-name class="desc-tlt">{{$t('design.case.optionalFiles') || '可传文件'}}</title-name>
                </div>
                <xl-form-item class="file-form-item" v-for="(item, index) in optionalFileList" :key="index">
                    <template #label>
                        <span>{{item.title}}</span>
                        <xl-tooltip :content="item.imageRemark" placement="top">
                            <i class="iconfont icon-zhuyi" v-show="item.imageRemark"></i>
                        </xl-tooltip>
                    </template>
                    <list-uploader
                        category="dentalx" 
                        :isPrivate="false"
                        drag 
                        listType="picture" 
                        :limit="item.limit"
                        isBigFile 
                        v-model:file-list="form[item.key]"
                        :tip="item.tip"                     
                        :accept="item.accept"
                        :typeErrorTip="item.tip"
                        :maxSize="item.maxSize"
                        :typeErrorList="item.typeErrorList"
                        :outOfSizeTip="item.outOfSizeTip"
                        :auto-upload="true"
                        @success="uploadedsuccess" 
                        :text="$t('design.case.addOrDragFile') || '添加或拖入文件'"
                        :show-file-list="false"
                        outOfLimitHideUpload
                        @error="uploadErrorHandler"
                        ></list-uploader>
                </xl-form-item>
                <div class="btns">
                    <xl-button @click="onClear"><xl-icon class="delete-icon" name="shanchu1" size="16"></xl-icon>{{$t('design.clearAll') || '清空'}}</xl-button>
                    <xl-button type="primary" plain @click="openImportDialog">{{$t('design.case.importFromOrder') || '从订单导入'}}</xl-button>
                </div>
            </div>
        </xl-form>
        </xl-scrollbar>
    </div>
    <div class="footer">
        <xl-button type="primary" @click="onNext">{{$t('design.goNext') || '下一步'}}</xl-button>
        <xl-button class="pre-btn" @click="onPre">{{$t('design.goBack') || '上一步'}}</xl-button>
    </div>
    <add-case-dialog ref="dialogRef" @import="onImport"></add-case-dialog>
  </div>
</template>

<script setup>
import { ref, defineEmits, defineExpose, watch, defineProps, onMounted } from 'vue';
import {
	XlButton,
	XlCheckbox,
	XlCheckboxGroup,
	XlDialog,
	XlForm,
	XlFormItem,
	XlIcon,
	XlInput,
	XlMessage,
	XlMessageBox,
	XlRow,
	XlSelect,
	XlTooltip,
	XlUpload2,
    XlLoading,
    XlScrollbar
} from '@shining3d/ui-components';
// import JSZip from 'jszip';
import { formatImageFile } from '../../utils/common.js';
import AddCaseDialog from './components/addCaseDialog.vue';
import ListUploader from './components/listUploader.vue';
import { useLang } from "@shining3d/common-module/utils/lang.js";
// import { upload } from '@shining3d/utils';
import { $lang } from '@shining3d/common-module/utils/index.js';
import Api from '../../api/case'; 
import TitleName from '../../components/titleName.vue';
import { useStore } from "vuex";
import _get from 'lodash/get';
const { $t } = useLang("@shining3d/xl-design-order");
const $store = useStore();
const _id = _get( $store, 'state.factorySelect.id', '' );
const dialogRef = ref(null);
const formRef = ref(null);
const orderID = ref('');

const props = defineProps({
    info: {
        type: Object,
        default: {}
    }
});

const emits = defineEmits(['pre', 'next']);
const rules = ref({
    orderName: [{ required: true, message: $t( 'rules.notEmpty' ), trigger: 'blur' }],
});

const form = ref({});

const requiredFileList = ref([]);
const optionalFileList = ref([]);
watch(() => props.info, (newValue, oldValue) => {
    if ( newValue.productType !== oldValue.productType ) {
        // 合并处理文件类型
        const uploadFileRestrict = newValue.uploadFileRestrict || {};
        if (uploadFileRestrict.required) {
            Object.keys(uploadFileRestrict.required).forEach(item => {
                const config = imageFileMap.value[item] || {}
                const obj = formatImageFile({
                    key: item,
                    limit: uploadFileRestrict.required[item],                 
                    ...config
                });
                form.value[item] = [];
                requiredFileList.value.push(obj);
            })
            requiredFileList.value?.sort((a,b) => a?.sort - b?.sort)
        } 
        if (uploadFileRestrict.optional) {
            Object.keys(uploadFileRestrict.optional).forEach(item => {
                const config = imageFileMap.value[item] || {}
                const obj = formatImageFile({
                    key: item,
                    limit: uploadFileRestrict.optional[item],
                    ...config
                });
                form.value[item] = [];
                optionalFileList.value.push(obj);
            })
            optionalFileList.value?.sort((a,b) => a?.sort - b?.sort)
        }
    }
});

const uploadedsuccess = () => {

};

const clearUploadFiles = () => {
    const { orderName, ...other } = form.value;
    Object.keys(other).forEach(key => {
        form.value[key] = [];
    });
};

const onClear = () => {
    XlMessageBox({
        title: $t( 'design.case.fileClear' ) || '确定清空',
        message: $t( 'design.case.clearAllFile' ) || '确定清楚所有的数据',
        cancelButtonText: $t( 'design.cancel' ),
        confirmButtonText: $t( 'design.confirm' )
    }).then(() => {
        clearUploadFiles();
    });
};

// const unzipFile = ( file ) => {
// 	return new Promise(( resolve, reject ) => {
// 		const zip = new JSZip();
// 		zip.
// 			loadAsync( file ).
// 			then(( zipTemp ) => {
//                 console.log( 'zipTemp', zipTemp.files);
// 				const keys = Object.keys( zipTemp.files );
// 				const files = [];
// 				keys.forEach(( key ) => {
// 					files.push( zipTemp.files[ key ]);
// 				});
// 				resolve( files );
// 			}).
// 			catch(( err ) => {
// 				reject( err );
// 			});
// 	});
// };

// const uploadBitFile = async ( file ) => {
//     const bit = await file.async('uint8array');
//     const fileName = file.name;
//     const size = file._data.compressedSize;
//     return new Promise(( resolve, reject ) => {
//         upload.submitBigFileUpload({
// 			category: 'audit',
// 			isPrivate: false
// 		}, {
// 			buffer: bit,
//             fileName,
//             onSuccess: ( res ) => {
// 				const url = $getCdnUrl({ bucket: res.bucket, dfsID: res.dfsID });
// 				resolve({
//                     name: fileName,
//                     url,
//                     size,
//                     response: {
//                         fileName,
//                         ...res
//                     }
//                 });
// 			},
//             onError: () => {
//                 reject()
//             }
//         });
//     });
// };

// 从订单导入
const openImportDialog = () => {
    dialogRef.value.show();
};

const importFail = () => {
    XlMessage({
        type: 'error',
        message: $t('design.order.importfail') || '订单导入失败'
    });
};

// 暂不用了，后端解析 zip 包文件
// const importFile = async ( row ) => {
//     // todo: 调用后端接口
//     // form.value.upfileList = [{
//     //     name: 'xxxx.beb'
//     // }];
//     // const url = $getCdnUrl({ bucket: file.bucket, dfsID: file.dfsID });
//     const url = "https://tchdown.shining3d.com/dentalFull%2Ff9b9ec92396414d872f9d720880feaf7?Expires=1722047246&OSSAccessKeyId=LTAI4G9xbn2fDWKhZgxVn6qK&Signature=wuv%2FZn4GBoI5zxRptVar1eFbj%2FY%3D"
//     console.log( 'url', url);
//     // 下载URL生成原始文件Blob
// 	const zipBlob = await $getBlobByUrl( url );
//     if ( zipBlob ) {
//         // 解压原始zip文件
// 		const files = await unzipFile( zipBlob );
//         // 遍历解压文件
// 		files.forEach(( v ) => {
//             console.log('zip file', v);
// 		});
//         // 找到上颌、下颌和咬合文件
//         const canFileList = files.filter( v => {
//             const name = v.name.toLocaleLowerCase();
//             return name.includes('upperjaw') || name.includes('lowerjaw') || name.includes('totaljaw');
//         });
        
//         console.log( 'canFileList', canFileList );
//         // const upfile1 = uploadBitFile( files[0]._data.compressedContent, files[0].name, 'upperJaw' );
//         const loadFiles = canFileList.map(item => uploadBitFile( item ));
//         Promise.all( loadFiles ).then(( res ) => {
//             form.value.bitfileList = []; // 先清空咬合文件
//             res.forEach( item => {
//                 if ( item.name.toLocaleLowerCase().includes('upperjaw') ) {
//                     form.value.upfileList = [ item ];
//                 } else if ( item.name.toLocaleLowerCase().includes('lowerjaw') ) {
//                     form.value.lowerfileList = [ item ];
//                 } else if ( item.name.toLocaleLowerCase().includes('totaljaw') ) {
//                     form.value.bitfileList.push( item );
//                 }
//             });
//         }).catch(() => {
//             importFail();
//         });
//     } else {
//         importFail();
//     }
// };
const caseFileRef = ref(null);
const loadingInstance = ref(null);
const onImport = ( row ) => {
    loadingInstance.value = XlLoading.service({
		target: caseFileRef.value,
		background: 'rgba(255,255,255,0.5)',
	});
    Api.loadDesignOrderFiles({
        orderID: row.id,
        orgID: _id,
    }).then( res => {
        loadingInstance.value?.close();
        if ( res && res.status === 'success' ) {
            const result = res.result || [];
            orderID.value = row.id;
            // 先清空所有的文件
            clearUploadFiles();
            
            result.forEach(item => {
                const obj = {
                    ...item,
                    name: item.fileName,
                    size: item.fileLength,
                    response: { ...item }
                };
                const { required, optional } = props.info.uploadFileRestrict || {};
                const allFilesKey = {
                    ...required,
                    ...optional
                };
                let detailType = item.detailType;
                if ( detailType.includes('totalJaw')) {
                    detailType = 'totalJaw';
                }
                if ( form.value[detailType] && form.value[detailType].length < allFilesKey[detailType] ) {
                    form.value[detailType].push( obj );
                }
                if ( !form.value[detailType] && allFilesKey['other']) {
                    form.value['other'].push( obj );
                }
            });
        }
    }).catch(() => {
        loadingInstance.value?.close();
        importFail();
    });
};

const flatFileList = (obj) => {
    // obj: uplower: [], lowerJaw: []
    let imageFile = [];
    // 平铺所有的文件成一维数组
    const requireFileKey = props.info.uploadFileRestrict?.required || {};
    Object.keys(obj).forEach(keyType => {
        if (obj[keyType].length) {
            const res = obj[keyType].map(item => {
                return {
                ...item.response, 
                status: item.status, 
                imageName: imageFileMap.value[keyType]?.imageName,
                required: requireFileKey[keyType] ? true : false
            }});
            res.forEach( i => {
                imageFile.push({
                    ...i,
                    detailType: keyType
                }); 
            });
        }
    });
    return imageFile;
};

const getValue = () => {
    const { orderName, ...other } = form.value;
    // 平铺所有的文件成一维数组
    const imageFile = flatFileList(other); 
    // 必传文件
    const requiredFiles = imageFile.filter(item => item.required);
    // 可传文件  
    const optionalFiles = imageFile.filter(item => !item.required);
    return {
        orderName,
        imageFile,
        requiredFiles,
        optionalFiles
    }
};

const onNext = () => {
    formRef.value.validate(( valid ) => {
        if ( valid ) {
            const res = validate();
            if (!res.valid) {
                if ( res.message ) {
                    XlMessage({
                        type: 'warning',
                        message: res.message
                    });
                }
                return;
            }
            const data = getValue();
            emits('next', {
                data,
                index: [0, 1, 2, 3]
            });
        }
    });
};

const onPre = () => {
    emits('pre');
};

const resetData = () => {
    form.value = {
        orderName: ''
    };
    requiredFileList.value = [];
    optionalFileList.value = [];
    formRef.value.clearValidate();
};

const validate = () => {
    const { orderName, ...other } = form.value;

    if ( !orderName ) {
        return {
            valid: false
        }
    }
    // 必传文件key other: {upLower: [], lowerJaw: []}, requireFileKey: {upLower: 1,lowerJaw:2 }
    const requireFileKey = props.info.uploadFileRestrict?.required || {};
    let flag = false;
    let tip = '';
    Object.keys(other).forEach(item => {
        if (requireFileKey[item] && !other[item].length) {
            flag = true;
            tip = imageFileMap.value[item]?.imageName
        }
    });
    if ( flag ) {
        return {
            valid: false,
            // `请上传${tip}`
            message: $t('design.case.filechoose', {
                tip: tip
            })
        }
    }

    const list = flatFileList(other);
    flag = list.some( item => item.status === 'uploading' );
    if ( flag ) {
        return {
            valid: false,
            message: $t('design.file.uploading') || '文件正在上传中，请稍后'
        };
    }
    return {
        valid: true
    }
};

const uploadErrorHandler = () => {
	XlMessage({ type: 'error', message: $t( 'design.dataAudit.uploadErr' ) });
};

const imageFileMap = ref({});
// 获取影像文件配置信息 
const getFileConfig = () => {
    Api.fetchImageSetting({
        lang: $lang()
    }).then( res => {
        if ( res && res.status === 'success' ) {
            const list = res.result || [];
            const obj = {};
            list.forEach(item => {
                obj[item.imageUniqueCode] = item;
            });
            imageFileMap.value = obj;
        }
    });
};

onMounted(() => {
    getFileConfig();
});

defineExpose({ resetData, validate, getValue });
</script>

<style lang="scss" scoped>
$case-border-color: #E0E4EA;
.choose-file-wrap {
    display: flex;
    flex: 1;
    flex-direction: column;
    height: 100%;
    // padding-right: 16px;
    padding-top: 24px;
    box-sizing: border-box;
    .content {
        flex: 1;
        box-sizing: border-box;
        // margin: 24px 16px 19px 16px;
        margin: 0px 0px 19px 0px;
        height: 100%;
        overflow-y: auto;
        // border-top: 1px dashed #E0E4EA;
        // padding-top: 16px;
        padding-left: 16px;

        .item {
            margin-right: 24px;
            min-height: 134px;
        }
        .tip {
            color: #737E99;
            line-height: 22px;
            margin-bottom: 4px;
            font-size: 12px;
            font-family: $font-family65;
            font-weight: 500;
        }

        .file-form-item {
            background: #FAFBFD;
            padding: 16px;
            border-radius: 6px;
        }

        :deep(.el-form-item__content) {
            align-items: flex-start;
        }
        :deep(.el-upload--picture) {
            background: #fff;
        }
        :deep(.el-upload-list--picture .el-upload-list__item) {
            width: 376px;
            box-sizing: border-box;
            border: 2px solid #E0E4EA;
            height: 80px;
            background: #fff;
        }
        :deep(.el-upload__tip) {
            line-height: 20px;
        }
        :deep(.xl-upload .el-upload__text) {
            line-height: 18px;
            margin-top: 4px;
        }
        :deep(.el-upload-list) {
            margin-top: 0px;
        }
        :deep(.xl-upload-hide) {
            .el-upload__tip {
                display: none;
            }
        }
        :deep(.el-upload-dragger) {
            display: flex;
        }
        :deep(.xl-upload-wrapper) {
            .el-upload__tip {
                display: flex;
                flex-direction: column;
                align-items: center;
            }
        }
        :deep(.el-form) {
            margin-right: 16px;
        }
        :deep(.el-form-item .el-form-item__label) {
            font-family: $font-family65;
            color: #42526E;
            margin-bottom: 4px;
            font-size: 14px;
            display: flex;
            align-items: center;
            .icon-zhuyi {
                color: #A5ACBE;
                padding-left: 8px;
                cursor: pointer;
            }
        }
        :deep(.el-form-item) {
            margin-bottom: 16px;
        }
        .totalJawTip {
            font-size: 12px;
            font-weight: 400;
            color: #737E99;
        }
        .files-wrap {
            position: relative;
            .btns {
                position: absolute;
                top: 0px;
                right: 0px;
                display: flex;
                align-items: center;

                .i-delete {
                    background: url('../../assets/image/delete.svg');
                    width: 16px;
                    height: 16px;
                    margin-right: 4px;
                }
                .delete-icon{
                    margin-right: 4px;
                }
            }
        }
    }

    .footer {
        margin-right: 16px;
        box-sizing: border-box;
        height: 68px;
        display: flex;
        border-top: 1px solid $case-border-color;
        align-items: center;
        flex-direction: row-reverse;

        .pre-btn {
            margin-right: 16px;
        }
    }
    .width26 {
        width: 264px;
    }
    .need-file {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;
    }
}

</style>